var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "at-sign"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0004 24.3501C21.3141 24.3501 24.0004 21.6638 24.0004 18.3501C24.0004 15.0364 21.3141 12.3501 18.0004 12.3501C14.6867 12.3501 12.0004 15.0364 12.0004 18.3501C12.0004 21.6638 14.6867 24.3501 18.0004 24.3501Z",
    stroke: "#B3C3DA",
    strokeWidth: 3.00312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.0004 12.3499V19.8499C24.0004 21.0434 24.4745 22.188 25.3184 23.0319C26.1623 23.8758 27.3069 24.3499 28.5004 24.3499C29.6939 24.3499 30.8385 23.8758 31.6824 23.0319C32.5263 22.188 33.0004 21.0434 33.0004 19.8499V18.3499C33.0002 14.9644 31.8547 11.6786 29.7503 9.0267C27.6459 6.37478 24.7062 4.51274 21.4093 3.74335C18.1125 2.97395 14.6523 3.34246 11.5914 4.78895C8.53052 6.23544 6.04898 8.67483 4.55027 11.7105C3.05156 14.7461 2.62383 18.1995 3.33663 21.5091C4.04943 24.8186 5.86084 27.7898 8.47633 29.9393C11.0918 32.0889 14.3575 33.2904 17.7425 33.3486C21.1274 33.4068 24.4325 32.3183 27.1204 30.2599",
    stroke: "#B3C3DA",
    strokeWidth: 3.00312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtSign);
export default __webpack_public_path__ + "static/media/at-sign.e4834421cd4d7b130184a89343194ebe.svg";
export { ForwardRef as ReactComponent };